import { useWizard } from '../../../context/WizardContext';
import { SubjectCard } from '../../../components/wizard/SubjectCard';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';
import { getSubjects } from '../../../database/subjects';
import { useTranslation } from '../../../context/LanguageContext';

export function Step1Subject() {
  const { state, setSubject } = useWizard();
  const { t } = useTranslation();
  const availableSubjects = getSubjects(state.selectedClass, state.selectedDepartment);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">{t('wizard.subjectTitle')}</h2>
        <p className="text-sm text-slate-500 mt-1">{t('wizard.subjectSubtitle')}</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {availableSubjects.map((subject) => (
          <SubjectCard
            key={subject.id}
            subject={subject}
            isSelected={state.selectedSubject?.id === subject.id}
            onSelect={setSubject}
          />
        ))}
      </div>
      <NavigationButtons />
    </div>
  );
}
